import { default as MuiFormControl } from '@mui/material/FormControl';

/**
 * FormControl provides context for form inputs like labels and helper text.
 *
 * Demos:
 *
 * - [Radio Button](https://unify.workiva.org/components/radio-button?tab=code)
 *
 * API:
 *
 * - [FormControl API](https://unify.workiva.org/components/radio-button?tab=props#formcontrol)
 */
export const FormControl = MuiFormControl;
export {
  type FormControlProps,
  formControlClasses,
} from '@mui/material/FormControl';
export * from './formControlModuleAugmentation';
